
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import SanityBlockContent from '~/components/Sanity/SanityBlockContent.vue';
import SanityDocument from '~/components/Sanity/SanityDocument.vue';
import SanityReference from '~/components/Sanity/SanityReference.vue';
import FaqsList from '~/components/UIComponents/FaqsList.vue';
import FaqsListItem from '~/components/UIComponents/FaqsListItem.vue';

@Component({
  components: {
    FaqsList,
    FaqsListItem,
    SanityBlockContent,
    SanityDocument,
    SanityReference,
  },
})
export default class SFaqList extends Vue {
  @Prop(String)
  readonly slug!: string;
  @Prop(String)
  readonly id!: string;

  showMore = 'Show More';
  showLess = 'Show Less';
  schema = SanityDocumentSchema.FAQ_LIST;
  childSchema = SanityDocumentSchema.FAQ_LIST_ITEM;
}
